import axios from "axios";


//to change
// export const BASE_URL = 'http://localhost:5002/api/';

// new api url


export const BASE_URL = 'https://api.chorullapalli.com/api/';  

export const publicRequest = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, 
    
  });

  // export const adminRequest = axios.create({
  //   baseURL: BASE_URL,
  //   withCredentials: true, 
  // });

  // export const sellerRequest = axios.create({
  //   baseURL: BASE_URL,
  //   withCredentials: true, 
  // });